/**
 * navigation-history.service.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

import { Injectable } from "@angular/core";
import { Event as RouterEvent, Router } from "@angular/router";
import { Subscription } from "rxjs/Rx";

import { RingBuffer } from "../support/utilities/ring-buffer";

/**
 * The number of router events to keep stored.
 * @devConfig
 */
const ROUTER_HISTORY_SIZE : number = 20;

/**
 * The {@link NavigationHistoryService} caches recent navigation events for
 * debugging and autofill purposes, as well as providing convenience methods for
 * interacting with the history and events.
 */
@Injectable()
export class NavigationHistoryService
{
    /**
     * The current router event logger subscription, if any. (cf. logAll)
     */
    private loggingSub : Subscription;

    /**
     * Whether the service is logging router events.
     */
    private isLogging : boolean = false;

    /**
     * Backing data structure to hold recent router event history.
     */
    private history : RingBuffer<RouterEvent> =
        new RingBuffer<RouterEvent>(ROUTER_HISTORY_SIZE);

    constructor (protected router : Router)
    {
        this.router.events.subscribe(
            (e : RouterEvent & {type : string}) => {
                e.type = e.constructor.name;
                this.history.add(e);
            });
    }

    /**
     * Retrieve the list of recent router events
     */
    public getRecent () : RouterEvent[]
    {
        console.info(this.history.list());
        return this.history.list();
    }

    /**
     * Enable logging of all router events
     */
    public logAll () : void
    {
        if (!this.isLogging)
        {
            this.loggingSub = this.router.events.subscribe(
                (e : RouterEvent) => console.log(e));
            this.isLogging = true;
        }
    }

    /**
     * Stop logging of all router events
     */
    public stopLogging () : void
    {
        if (this.isLogging)
        {
            this.loggingSub.unsubscribe();
            this.isLogging = false;
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/debug/navigation-history.service.ts